export function configureFakeBackend() {
    let fakeData = []

    fetch('./json/fakeData.json').then(response => {
        return response.json();
    }).then(data => {
        fakeData = data;
    }).catch(err => {
        console.log("Error Reading data " + err);
    });

    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        //const isLoggedIn = opts.headers['Authorization'] === 'Bearer fake-jwt-token';

        return new Promise((resolve) => {
            // wrap in timeout to simulate server api call
            setTimeout(() => {
                // authenticate - public
                if (url.endsWith('/Api/GetProductionOrders') && opts.method === 'GET') {
                    return ok(fakeData.orders);
                }

                if (url.endsWith('/Api/GetMaterials') && opts.method === 'GET') {
                    return ok(fakeData.materials);
                }

                if (url.endsWith('/Api/GetArticles') && opts.method === 'GET') {
                    return ok(fakeData.articles);
                }

                if (url.includes('/Api/PauseOrderById') && opts.method === 'PUT') {
                    fakeData.orders.find(x => x.id === parseInt(url.charAt(url.length - 1))).state = "paused"
                    return ok(fakeData.orders);
                }

                if (url.includes('/Api/StartOrderById') && opts.method === 'PUT') {
                    fakeData.orders.find(x => x.id === parseInt(url.charAt(url.length - 1))).state = "running"
                    return ok(fakeData.orders);
                }

                if (url.endsWith('/Api/GetTransportOrdersHistory') && opts.method === 'GET') {

                    return ok(fakeData.transportOrdersHistory);
                }

                if (url.endsWith('/Api/GetActiveTransportOrders') && opts.method === 'GET') {

                    return ok(fakeData.activeTransportOrders);
                }

                if (url.endsWith('/Api/CreateNewBooking') && opts.method === 'POST') {

                    return ok([]);
                }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 6));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=7') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 7));
                // }

                if (url.includes('/Api/GetQualityChecksByOrderId') && opts.method === 'GET') {

                    let orderId = 0;
                    if (parseInt(url.charAt(url.length - 1)) > 0) {
                        orderId = parseInt(url.charAt(url.length - 1))
                    }
                    else {
                        orderId = (parseInt(url.charAt(url.length - 2)) * 10) + parseInt(url.charAt(url.length - 1))
                    }

                    return ok(fakeData.qualitychecks.filter(x => x.orderId === orderId));
                }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=8') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 8));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=9') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 9));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=10') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 10));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=11') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 11));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=12') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 12));
                // }


                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 6));
                // }


                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 6));
                // }


                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=1') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 1));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=2') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 2));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=3') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 3));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=4') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 4));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=5') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 5));
                // }

                // if (url.endsWith('/Api/GetQualityChecksByOrderId?id=6') && opts.method === 'GET') {
                //     return ok(fakeData.qualitychecks.filter(x => x.orderId === 6));
                // }


                if (url.endsWith('/Api/GetOperators') && opts.method === 'GET') {
                    return ok(fakeData.operators);
                }

                if (url.endsWith('/Api/GetQualityCheckSteps') && opts.method === 'GET') {
                    return ok(fakeData.qualityCheckSteps);
                }

                if (url.endsWith('/Api/GetMachineParameters') && opts.method === 'GET') {
                    return ok(fakeData.machineParameters);
                }

                if (url.endsWith('/Api/GetWorkstations') && opts.method === 'GET') {
                    return ok(fakeData.workstations);
                }

                if (url.endsWith('/Api/GetWorkstationStatusses') && opts.method === 'GET') {
                    return ok(fakeData.workstationStatusses);
                }

                if (url.endsWith('/Api/GetShifts') && opts.method === 'GET') {
                    return ok(fakeData.shifts);
                }

                if (url.endsWith('/Api/GetProgressions') && opts.method === 'GET') {
                    return ok(fakeData.progressions);
                }

                if (url.endsWith('/Api/GetRestrictions') && opts.method === 'GET') {
                    return ok(fakeData.restrictions);
                }

                if (url.endsWith('/Api/GetWorkingHours') && opts.method === 'GET') {
                    return ok(fakeData.workingHours);
                }

                if (url.endsWith('/Api/GetRestrictionTypes') && opts.method === 'GET') {
                    return ok(fakeData.restrictionTypes);
                }

                // get users - secure
                // if (url.endsWith('/users') && opts.method === 'GET') {
                //     if (!isLoggedIn) return unauthorised();
                //     return ok(users);
                // }

                // pass through any requests not handled above
                console.log()
                realFetch(url, opts).then(response => resolve(response)).catch(err => {
                    alert("Failed to fetch, no connection to backend!")
                  });

                // private helper functions

                function ok(body) {
                    resolve({ ok: true, text: () => Promise.resolve(JSON.stringify({ body })) })
                }

                // function unauthorised() {
                //     resolve({ status: 401, text: () => Promise.resolve(JSON.stringify({ message: 'Unauthorised' })) })
                // }

                // function error(message) {
                //     resolve({ status: 400, text: () => Promise.resolve(JSON.stringify({ message })) })
                // }
            }, 500);
        });
    }
}

